import { render, staticRenderFns } from "./CampusManagement.vue?vue&type=template&id=b9645d82&scoped=true&"
import script from "./CampusManagement.vue?vue&type=script&lang=js&"
export * from "./CampusManagement.vue?vue&type=script&lang=js&"
import style0 from "./CampusManagement.vue?vue&type=style&index=0&id=b9645d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9645d82",
  null
  
)

export default component.exports